import store from '@/store';

export default class RefreshAttendanceGroupDataEvent {
  constructor() {
    const agentId = store.state.attendance.Attendance.agentId;
    store.dispatch('attendanceGroups/getAttendanceGroups', agentId);
    store.dispatch('whatsappCampaigns/getAgentWhatsappCampaigns', agentId);
    store.dispatch('voice/getCampaignsVoiceByAgent', agentId);
  }
}
